import { ActionIcon, CopyButton, Tooltip, type MantineSize } from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';

interface CopyProps {
    value: string;
    timeout?: number;
    stopPropagation?: boolean;
    size?: MantineSize;
    iconSize?: number;
}

export const Copy = ({ value, timeout = 2000, stopPropagation = false, size, iconSize = 16 }: CopyProps) => (
    <CopyButton
        value={value}
        timeout={timeout}
    >
        {({ copied, copy }) => (
            <Tooltip
                label={copied ? 'Скопировано' : 'Скопировать'}
                withArrow
                position='right'
            >
                <ActionIcon
                    color={copied ? 'teal' : 'gray'}
                    variant='subtle'
                    size={size}
                    aria-label={copied ? 'Скопировано' : 'Скопировать'}
                    onClick={(e) => {
                        if (stopPropagation) {
                            e.stopPropagation();
                        }

                        copy();
                    }}
                >
                    {copied ? <IconCheck size={iconSize} /> : <IconCopy size={iconSize} />}
                </ActionIcon>
            </Tooltip>
        )}
    </CopyButton>
);
